import { getActiveTournament, clearAllCache } from './supabaseData';

// ─── Tournament ─────────────────────────────────────────────────

let tournamentPromise = null;

/**
 * Initialize tournament from Supabase and cache in localStorage.
 * Returns the tournament object { id, name, short_name }.
 * Deduplicates concurrent calls.
 */
export const initTournament = async () => {
  if (!tournamentPromise) {
    tournamentPromise = getActiveTournament();
  }
  const tournament = await tournamentPromise;
  if (tournament && typeof window !== 'undefined') {
    localStorage.setItem('activeTournamentId', tournament.id);
    localStorage.setItem('activeTournamentName', tournament.name);
  }
  return tournament;
};

/**
 * Get cached tournament ID from localStorage (synchronous, for initial render).
 */
export const getSavedTournament = () => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('activeTournamentId') || null;
};

/**
 * Get cached tournament name from localStorage.
 */
export const getTournamentTitle = () => {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem('activeTournamentName') || '';
};

/**
 * Tournament logo CSS class. Hardcoded to 'ipl' until we add a logo column.
 */
export const getTournamentLogo = () => 'ipl';

// ─── Utils ──────────────────────────────────────────────────────

/**
 * Get color mode from localStorage.
 */
export const getColorMode = () => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('darkModeCheckbox');
};

/**
 * Clear all localStorage cache keys.
 */
export const resetLocalStorage = () => {
  clearAllCache();
};
